import MediaList from "./MediaList"
import MediaCreate from './MediaCreate'
import MediaEdit from './MediaEdit'

export default {
    list: MediaList,
    edit: MediaEdit,
    create: MediaCreate
}